import { FormikHelpers, FormikValues } from 'formik';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { number, object } from 'yup';

import Botao from 'Component/Botao';
import Form, { Selecao } from 'Component/Form';
import Modal from 'Component/Modal';
import { useRecuperarVinculosEmpregaticiosQuery } from 'View/Service/Default/VinculosEmpregaticios';

const regras = object({
  vinculo_id: number().required('Obrigatório'),
});

const Impressos = (): React.ReactElement => {
  const { id = 0 } = useParams();
  const [modal, setModal] = useState<boolean>(false);
  const [url, setUrl] = useState<string>();

  const { data: { vinculos } = {} } = useRecuperarVinculosEmpregaticiosQuery({
    finder: 'listaJson',
    contain: ['Empresas'],
    options: { usuario_id: id },
  });

  const selecionar = (url: string): void => {
    setUrl(url);
    setModal(true);
  };

  const imprimir = (dados: { vinculo_id: number }, form: FormikHelpers<FormikValues>): void => {
    window.open(`${url}/${dados.vinculo_id}`);

    form.setSubmitting(false);
  };

  return (
    <React.Fragment>
      <div className="bg-white shadow-sm rounded">
        <div
          className="d-flex border-bottom align-items-center justify-content-between py-2 px-3"
          onClick={() => selecionar('/documentos/1')}
        >
          <div className="fs-4">Formulário</div>
        </div>
        <div
          className="d-flex border-bottom align-items-center justify-content-between py-2 px-3"
          onClick={() => selecionar('/documentos/2')}
        >
          <div className="fs-4">Formulário resumido</div>
        </div>
        <div
          className="d-flex border-bottom align-items-center justify-content-between py-2 px-3"
          onClick={() => selecionar('/documentos/3')}
        >
          <div className="fs-4">Exame demissional</div>
        </div>
        <div
          className="d-flex border-bottom align-items-center justify-content-between py-2 px-3"
          onClick={() => selecionar('/documentos/4')}
        >
          <div className="fs-4">Aviso prévio do empregador</div>
        </div>
        <div
          className="d-flex border-bottom align-items-center justify-content-between py-2 px-3"
          onClick={() => selecionar('/documentos/5')}
        >
          <div className="fs-4">Termo de uniforme</div>
        </div>
        <div
          className="d-flex border-bottom align-items-center justify-content-between py-2 px-3"
          onClick={() => selecionar('/documentos/6')}
        >
          <div className="fs-4">Aviso Antecipado de término de contrato de Experiência</div>
        </div>
        <div
          className="d-flex border-bottom align-items-center justify-content-between py-2 px-3"
          onClick={() => selecionar('/documentos/7')}
        >
          <div className="fs-4">Aviso de Término de contrato de Experiência</div>
        </div>
        <div
          className="d-flex border-bottom align-items-center justify-content-between py-2 px-3"
          onClick={() => selecionar('/documentos/8')}
        >
          <div className="fs-4">Abertura de conta salário</div>
        </div>
        <div
          className="d-flex border-bottom align-items-center justify-content-between py-2 px-3"
          onClick={() => selecionar('/documentos/9')}
        >
          <div className="fs-4">Entrega de EPI</div>
        </div>
        <div
          className="d-flex border-bottom align-items-center justify-content-between py-2 px-3"
          onClick={() => selecionar('/documentos/10')}
        >
          <div className="fs-4">Entrega de uniforme</div>
        </div>
        <div
          className="d-flex border-bottom align-items-center justify-content-between py-2 px-3"
          onClick={() => selecionar('/documentos/11')}
        >
          <div className="fs-4">Avaliação do período de experiência</div>
        </div>
      </div>
      <Modal
        exibir={modal}
        aoFechar={setModal}
        titulo="Selecionar vinculo empregatício"
      >
        <Form onSubmit={imprimir} regras={regras}>
          <Selecao name="vinculo_id" rotulo="Vinculo" opcoes={vinculos} />
          <Botao type="submit">Imprimir</Botao>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default Impressos;
